// @ts-check
import { useMutation, useQueryClient } from '@tanstack/react-query';
import useSnackbarError from 'utility/hooks/useSnackbarError';
import toast from '@liquidweb-dev/undercurrent/toast';
import api from 'modules/queries/api';

const useCreateLoadBalancer = () => {
	const queryClient = useQueryClient();
	const snackbarError = useSnackbarError();

	return useMutation({
		mutationFn:
			/** @param {import('club-sauce/public/network/loadbalancer/index.raw').LWApiPublicNetworkLoadBalancerCreateParamsI} params */
			(params) => api.network.loadbalancer.apiRaw.create(params),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['/asset/list'],
			});

			toast.success('Successfully created load balancer');
		},
		onError: snackbarError,
	});
};

export default useCreateLoadBalancer;
